<template>
    <div class="toast-container">
        <transition-group name="toast" tag="div">
            <div v-for="toast in toasts" :key="toast.id"
                 :class="['notification', toast.type === 'success' ? 'is-success' : 'is-danger', 'toast-item', { 'is-clickable': toast.type === 'success' }]"
                 @click="toast.type === 'success' && removeToast(toast.id)">
                <button v-if="toast.type === 'danger'" class="delete" @click.stop="removeToast(toast.id)"></button>
                <span class="toast-message">{{ toast.message }}</span>
                <div v-if="toast.type === 'success'" class="toast-progress">
                    <div class="toast-progress-bar" :style="{ animationDuration: toast.duration + 'ms' }"></div>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        name: 'ToastContainer',
        data() {
            return {
                toasts: []
            };
        },
        mounted() {
            eventBus.$on('toast', (toast) => {
                const duration = toast.duration || 4000;
                this.toasts.push({ ...toast, duration });

                if (toast.type === 'success') {
                    setTimeout(() => {
                        this.removeToast(toast.id);
                    }, duration);
                }
            });
        },
        beforeDestroy() {
            eventBus.$off('toast');
        },
        methods: {
            removeToast(id) {
                const index = this.toasts.findIndex(t => t.id === id);
                if (index !== -1) {
                    this.toasts.splice(index, 1);
                }
            }
        }
    };
</script>

<style scoped>
    .toast-container {
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 9999;
    }

    .toast-item {
        width: 320px;
        margin-top: 8px;
        overflow: hidden;
        padding-bottom: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .toast-message {
        flex: 1;
        display: flex;
        align-items: center;
        padding-bottom: 4px;
    }

    .is-clickable {
        cursor: pointer;
    }

    .toast-progress {
        height: 4px;
        background: rgba(0, 0, 0, 0.15);
        margin-top: 8px;
        border-radius: 2px;
        overflow: hidden;
    }

    .toast-progress-bar {
        height: 100%;
        background: rgba(255, 255, 255, 0.7);
        width: 100%;
        animation: drain linear forwards;
    }

    @keyframes drain {
        from { width: 100%; }
        to { width: 0%; }
    }

    .toast-enter-active, .toast-leave-active {
        transition: all 0.3s ease;
    }

    .toast-enter, .toast-leave-to {
        opacity: 0;
        transform: translateY(-16px);
    }
</style>
